import { computed } from 'vue'

import { useConfigStore } from '../stores/config'

export function useCoverImage () {
  const configStore = useConfigStore()
  const rsConfig = computed(() => configStore.rsConfig)

  /**
   * For the cover image overlay on the teaser, we have stored URLs with a fixed
   * image size in the database from the previous integration.
   * For the new integration, the image size is requested to fit the viewport.
   * For this purpose, the URL is first generated in the client,
   * and therefore, we will only store the magazine name.
   */
  function coverImageUrl (magazine: string, width: number, seoName = 'auto', type = 'webp'): string {
    if (seoName === 'auto') seoName = `titelbild-der-zeitschrift-${magazine}`
    return `${rsConfig.value.imageServiceUrl}/${seoName},id=${magazine},b=cover-images,w=${width},rm=sk.${type}`
  }

  /**
   * Fallback for the old database value to extract the magazine name from the URL,
   * provided the value matches the URL scheme.
   * If this is not the case, the magazine name must be used as the new value.
   */
  function extractMagazineName (oldCoverUrl: string): string {
    const match = oldCoverUrl.match(/^https:\/\/cdn\.xceler8\.io\/cover\/([^\/]+)\.jpg$/)
    return mapMagazineName(match ? match[1] : oldCoverUrl)
  }

  /**
   * We've previously written magazine names with multiple words together and now separate them with a hyphen.
   * Therefore, we need a small mapping for the fallback.
   */
  function mapMagazineName (name: string): string {
    const mapping: Record<string, string> = {
      allesfuerdiefrau: 'alles-fuer-die-frau',
      aufeinenblick: 'auf-einen-blick',
      dasneueblatt: 'das-neue-blatt',
      neuepost: 'neue-post',
      schoenewoche: 'schoene-woche',
      meinlieblingsrezept: 'mein-lieblingsrezept',
      wocheheute: 'woche-heute',
      dasneue: 'das-neue',
      machmalpause: 'mach-mal-pause'
    }
    return mapping[name] || name
  }

  return {
    coverImageUrl,
    extractMagazineName
  }
}
